import { DialogProps } from './dialog.props';

export const DialogPresets: DialogProps = {
  clickOutsideToClose: false,
  closable: true,
  level: 0,
  variant: 'standard',
};
